import { Gender, Languages } from '../types';

export type UserOrganisations = {
    /**
     * The key for the organisation
     * @example "demo"
     */
    [key: string]: {
        /**
         * Whether or not the user is enabled for the organisation. This setting is controlled by
         * the organisation admin(s)
         */
        enabled: boolean;
        /**
         * User-friendly name for the organisation
         */
        name: string;
        /**
         * User who approved organisation access through management portal
         */
        approvedBy?: string;
        /**
         * User preferences split into languages and specialities
         */
        preferences?: {
            languages?: Languages[];
            specialities?: string[];
        };
        /**
         * Start datetime of user absence
         */
        absenceStartDateTime?: string;
        /**
         * Is the user absent or not
         */
        absent?: boolean;
        /**
         * Is the user available for this organisation or not
         */
        available?: boolean;
        /**
         * HCP band
         */
        band?: string;
        /**
         * The responsibility of the user for a given day either responser or co-ordinator
         */
        hcpDayResponsibility?: Array<{ date?: string; hcpDayResponsibility?: string[] }>;
        /**
         * Sesui secure comms info
         */
        sesui?: {
            operatorId?: string;
            password?: string;
            phoneNumber: string;
        };
    };
};

export interface IUser {
    /**
     * The user's unique ID in the format firstname.lastname[increment]. This is the database
     * primary key
     * @example "joe.bloggs1"
     */
    userId: string;
    userName?: string;
    /**
     * Version of the terms accepted on mobile
     */
    acceptedTerms?: string;
    /**
     * I think its only 'unified'
     */
    accountType?: string;
    /**
     * Token created for android
     */
    androidToken?: string;
    /**
     * Token created for iOS
     */
    iosToken?: string;
    currentPractices?: string[];
    dateOfBirth?: string;
    email?: string;
    gender?: Gender;
    lastKnownLocationTime?: string;
    lastUpdatedAt?: string;
    lastUpdatedBy?: string;
    latitude?: number;
    longitude?: number;
    maxDriveTimeMinutes?: string;
    onboardingId?: string;
    phoneNumber?: string;
    professionalBodyId?: string;
    professionalBodyType?: string;
    role?: string;

    /**
     * The organisations that the user belongs to and their settings for that organisation
     */
    organisations?: UserOrganisations;
    /**
     * The user's username for TTP SystmOne, relevant only for users belonging to organisations that
     * have SystmOne integration enabled
     * @example "jblogs0001"
     */
    s1Username?: string;
    /**
     * The user hcptypes help determine what roles they are suitable for via on demand jobs.
     */
    hcpTypes?: string[];
}

interface User extends IUser {}

class User {
    constructor(data: IUser) {
        Object.assign(this, data);
    }
}

export { User };
